export default __webpack_public_path__ + "static/home-ad17bb43f5faedb07d50438e18dc47e8.png";